import { render, staticRenderFns } from "./KabTolikara.vue?vue&type=template&id=375640c3"
import script from "./KabTolikara.vue?vue&type=script&lang=js"
export * from "./KabTolikara.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports